import { PathBase } from "@constellation-academy/epic-ui";

export class LicensesPath extends PathBase {
	static readonly pathKey = "licenses";
}
